var _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#0F4C81",
    stroke: "#0F4C81",
    strokeWidth: 15,
    width: 30,
    height: 30,
    x: 25,
    y: 85
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    dur: 2,
    values: "1;0;1;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.4
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0F4C81",
    stroke: "#0F4C81",
    strokeWidth: 15,
    width: 30,
    height: 30,
    x: 85,
    y: 85
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    dur: 2,
    values: "1;0;1;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#0F4C81",
    stroke: "#0F4C81",
    strokeWidth: 15,
    width: 30,
    height: 30,
    x: 145,
    y: 85
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    dur: 2,
    values: "1;0;1;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.cc51828453208aa23ccee2c7c16c74ac.svg";
export { ForwardRef as ReactComponent };